import {
  Box,
  styled,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
} from '@mui/material';

export const StyledTableContainer = styled(TableContainer)(() => ({
  height: '100%',
}));

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.grey[800],
}));

export const StyledTableCellWide = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[700]}`,
  fontSize: 12,
  fontWeight: 700,
  width: theme.spacing(100),
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[700]}`,
  fontSize: 12,
  fontWeight: 700,
  width: theme.spacing(25),
}));

export const StyledTypography = styled(Typography)(() => ({
  fontSize: 12,
  fontWeight: 400,
}));

export const StyledCrownAndTextContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFreeAccount',
})<{ isFreeAccount?: boolean }>(({ theme, isFreeAccount }) => ({
  display: 'flex',
  alignItems: 'center',
  color: isFreeAccount ? theme.palette.grey[500] : 'inherit',
}));
